import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

export const ProductItemFlowContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productItemFlowContainer, style]} />
);

const styles = StyleSheet.create({
  productItemFlowContainer: {
    backgroundColor: primitive.$white,
    width: '100%',
  },
});
